import jwt_decode from 'jwt-decode';
import StorageService from './storage';

const TOKEN = 'ci_hp';

export const removeTokens = () => {

  StorageService.removeItem(TOKEN);
};

export const getToken = () => {
  return StorageService.getItem(TOKEN);
};

export const getRole = () => {
  return getTokenField('roles')[0];
};

export const getDecodedToken = () => {
  const token = StorageService.getItem(TOKEN);
  try {
    return jwt_decode(token);
  } catch (error) {
    return null;
  }
};

export const getAccountId = () => {
  return getTokenField('account_id');
};

export const getTokenField = field => {
  const decodedToken = getDecodedToken() || {};

  return decodedToken[field] ? decodedToken[field] : false;
};

export const getPaymentMethod = () => {
  const decodedToken = getDecodedToken() || {};
  return decodedToken.payment_method ? decodedToken.payment_method : '';
};

